<!-- <div class="modal-header position-relative">
  <h4>{{ welcomeDialogData.header }}</h4>
  
</div> -->
<div class="position-relative">
  <span class="cursor-pointer close-dialog position-absolute" (click)="welcomeDialogRef.close()">
    <img
      class="resp-image"
      src="https://media.umangapp.in/cdn/landing/close.svg"
      alt="close"
      width="12px"
      height="12px"
      loading="lazy"
      fetchpriority="high"
      
    />
  </span>
  <img role="button" width="700px" height="394px" [src]="notifyDialogData?.image" alt="manas" class="w-100 h-auto" (click)="openLinkSameTab(notifyDialogData?.redirectUrl)">
</div>
